const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
var vehicleInterval;
window.productMedia = mediaJSON;
class templateProductJS {
    constructor() {
        var _this = this;
        localStorage.setItem('prd_url', `${window.location.pathname}${window.location.search}`);
        if(selectors.reviewratingEle){
            selectors.reviewratingEle.addEventListener('click', (event)=>{
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if(reviewSection) reviewSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            });
        }

        selectors.zoomBtns.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });

        document.getElementById("scroll-top-btn").onclick = function() {  
            window.scrollTo({top: 0, behavior: 'smooth'});
        }; 

        //document.body.appendChild(document.createElement("script")).src = 'static.nexusmedia-ua.com/easysearch/externals/frontend/easysearch-1.0.1.js';

        var selectionBox = document.querySelector('.product-details-wrapper .product-select-vehicle-wrapper');
        if(selectionBox != null){
            vehicleInterval = setInterval(_this.checkVehicleFit, 1000);
            this.switchOrSelectVehicle();
        }

        var checkAddintionalCheckout = setInterval(() => {
            var additionCheckoutBtn = document.querySelector("[desktop-additional-checkout] #dynamic-checkout-cart");
            if (additionCheckoutBtn != null) {
                var additionalChekcoutData = document.querySelector("[desktop-additional-checkout] #dynamic-checkout-cart").innerHTML;
                if (additionalChekcoutData != null && additionalChekcoutData != "") {
                    clearInterval(checkAddintionalCheckout);
                    if (window.innerWidth <= 576) {
                        document.querySelector("[mobile-additional-checkout]").innerHTML = document.querySelector("[desktop-additional-checkout]").innerHTML
                    }
                }   
            }
        }, 1000);

        var count = 0;
        var gPayButtonOnPdp = setInterval(() => {
            var gPayButtonOnPdpBtn = document.querySelector(".dynamic-checkout-button [data-testid='grid-cell']:nth-child(3)");
            if (gPayButtonOnPdpBtn == null && count > 5) {
                document.querySelector('.product-info .add-to-cart-btn-wrapper .add-to-cart-btn').style.maxWidth = "100%";
                document.querySelector('[desktop-additional-checkout]').remove();
                clearInterval(gPayButtonOnPdp);
            } else if(gPayButtonOnPdpBtn != null) {
                clearInterval(gPayButtonOnPdp);
            }
            count++;
        }, 1000)

        
        // var poCount = 0;
        // var productOptionPricePdp = setInterval(() => {
        //     var productOptionPricePdpBtn = document.querySelector("[data-hulkapps-product-options] .hulkapps_product_options");
        //     if (productOptionPricePdpBtn != null && poCount <= 10) {
        //         console.log('options detected');
        //         this.setupPOAppFunction();
        //         this.setupProductHiddenProperties();
        //         this.POAppApiCall();
        //         clearInterval(productOptionPricePdp);
        //     } else if(poCount > 10) {
        //         clearInterval(productOptionPricePdp);
        //     }
        //     poCount++;
        // }, 1000)

    }

    // POAppApiCall() {
    //     fetch('/community/api/get-product-option-values')
    //     .then((res) => (res.json()))
    //     .then((data) =>  {
    //         var allPOoptions = document.querySelectorAll('.hulkapps_option_set .hulkapps_option');
    //         if (allPOoptions.length > 0) {
    //             allPOoptions.forEach(item => {
    //                 var selectionList = item.querySelector('select[data-option-key]');
    //                 if (selectionList != null) {
    //                     var id = selectionList.getAttribute('id');
    //                     selectionList.querySelectorAll('option').forEach(item => {
    //                         var itemVal = item.getAttribute('value');
    //                         if (itemVal != null && itemVal != "") {
    //                             !data[id][itemVal] ? (selectionList.querySelector(`[data-conditional-value="${itemVal}"]`) != null && selectionList.querySelector(`[data-conditional-value="${itemVal}"]`).setAttribute('disabled', 'disabled')) : '';
    //                         }
    //                     })
    //                 }
    //             })
    //         }
    //     })
    // }

    setupProductHiddenProperties() {
        const that = this;
        var allPOoptions = document.querySelectorAll('.hulkapps_option_set .hulkapps_option');
        if (allPOoptions.length > 0) {
            var html = ``;
            allPOoptions.forEach(item => {
                var selectionList = item.querySelector('select[data-option-key]');
                if (selectionList != null) {
                    var id = selectionList.getAttribute('id');
                    var val = selectionList.value;
                    html += `<input type="hidden" name="properties[_${id}]" value="${val}" />`   
                    selectionList.addEventListener('change', function(e) {
                        that.changePOoptionValue(selectionList, id);
                    })
                }
            })
            document.querySelector('product-form form').insertAdjacentHTML('beforeend', html);
        }
    }

    changePOoptionValue(select, id) {
        var valueData = select.value;
        var value = select.querySelector(`option[value="${valueData}"]`).getAttribute('data-conditional-value');
        document.querySelector(`[name="properties[_${id}]"]`).value = value;
    }

    setupPOAppFunction() {
        // for price update.
        var priceSelectorPOApp = document.querySelector("#option_display_total_format");
        if (priceSelectorPOApp != null) {
            const observe = new MutationObserver(function() {
                console.log('callback that runs when observer is triggered');
                var additionalPrice = parseInt(parseFloat(document.querySelector("#calculated_option_total").innerHTML) * 100);
                var productPrice = parseInt(document.querySelector('[data-productprice]').getAttribute('data-productprice'));
                document.querySelector('[data-productprice]').innerHTML = Shopify.formatMoney((additionalPrice + productPrice), window.globalVariables.money_format);
            });
            observe.observe(document.querySelector("product-form"), {childList: true, childList: true, characterData: true, subtree: true});
        }
    }

    checkVehicleFit(){
        if(window.easysearch != undefined){
            clearInterval(vehicleInterval);
            var vehicleSelectEle = document.getElementsByClassName('vehicle-select');
            var vehicleClickEvent = function() {
                document.getElementById('selectVehicle').click();
            }
            for (var i = 0; i < vehicleSelectEle.length; i++) {
                vehicleSelectEle[i].addEventListener("click", vehicleClickEvent, false);
            }
            setTimeout(() => {
                if(window.easysearch.preSelect.length > 0){
                    var vehicleNameElements = document.querySelectorAll('[data-vehicle-name]');
                    var preSelect = window.easysearch.preSelect.filter(item => item != '');
                    preSelect.forEach(function(value,index){
                        if(window.globalVariables.product.tags.includes(value.toLowerCase()) || window.globalVariables.product.tags.includes(value)){
                            if(index == preSelect.length-1){
                                document.querySelector('[data-vehicle-success]').classList.remove('d-none');
                                document.querySelector('[data-vehicle-success]').classList.add('d-flex');
                                document.querySelector('[data-select-vehicle]').classList.add('d-none');
                            }
                        }else{
                            document.querySelector('[data-select-vehicle]').classList.add('d-none');
                            document.querySelector('[data-vehicle-failed]').classList.remove('d-none');
                            document.querySelector('[data-vehicle-failed]').classList.add('d-flex');
                            return false;
                        }
                    });
                    vehicleNameElements.forEach(function(element) {
                        element.innerHTML = window.easysearch.preSelect.join(' ').trim();
                    });
                    var vehicleNameElementsDesktop = document.querySelectorAll('[data-desktop-vehicle-name]');
                    if (vehicleNameElementsDesktop.length > 0) {
                        vehicleNameElementsDesktop.forEach((item) => {
                            item.innerHTML = window.easysearch.preSelect.join(' ').trim().slice(0, 13) + '...';
                        })
                    }
                }else if(window.easysearch.preSelect.length == 0){
                    document.querySelector('[data-select-vehicle]').classList.remove('d-none');
                    document.querySelector('[data-select-vehicle]').classList.add('d-flex');
                }
            }, 1500);
        }
    }

    switchOrSelectVehicle() {
        const that = this;
        var vehicleSelectionBtn = document.querySelector('.template-product #VehicleSearch-modal .easysearch-btn-holder #easysearch-search');
        // if (vehicleSelectionBtn != null) {
        //     vehicleSelectionBtn.addEventListener('click', function(e) {
        //         e.preventDefault();
        //         document.querySelector('#VehicleSearch-modal #ModalClose-video').click();
        //         var curIndex = window.easysearch.curIndex.split(',');
        //         if(curIndex.length > 0){
        //             var vehicleNameElements = document.querySelectorAll('[data-vehicle-name]');
        //             var preSelect = curIndex.filter(item => item != '');
        //             preSelect.forEach(function(value,index){
        //                 if(window.globalVariables.product.tags.includes(value.toLowerCase()) || window.globalVariables.product.tags.includes(value)){
        //                     if(index == preSelect.length-1){
                                
        //                         document.querySelector('[data-vehicle-success]').classList.remove('d-none');
        //                         document.querySelector('[data-vehicle-success]').classList.add('d-flex');
        //                         document.querySelector('[data-vehicle-failed]').classList.add('d-none');
        //                         document.querySelector('[data-select-vehicle]').classList.add('d-none');
        //                         document.querySelector('[data-select-vehicle]').classList.remove('d-sm-flex');
        //                     }
        //                 }else{
        //                     document.querySelector('[data-select-vehicle]').classList.remove('d-sm-flex');
        //                     document.querySelector('[data-select-vehicle]').classList.add('d-none');
        //                     document.querySelector('[data-vehicle-success]').classList.add('d-none');
        //                     document.querySelector('[data-vehicle-failed]').classList.remove('d-none');
        //                     document.querySelector('[data-vehicle-failed]').classList.add('d-flex');
        //                     return false;
        //                 }
        //             });
        //             vehicleNameElements.forEach(function(element) {
        //                 element.innerHTML = curIndex.join(' ').trim();;
        //             });
        //         }else if(curIndex.length == 0){
        //             document.querySelector('[data-select-vehicle]').classList.remove('d-none');
        //             document.querySelector('[data-select-vehicle]').classList.add('d-sm-flex');
        //         }
        //         setTimeout(() => {
        //             window.history.pushState({}, '', localStorage.getItem('prd_url'));
        //         }, 100);
        //     })
        // }
    }

    manageVariantSlider(variant){
        const productJSON = window.globalVariables.product;
        const productSliderType = selectors.productContainer.dataset.slider_type;

        if(productSliderType == 'color-based' && productJSON.options && productJSON.options.includes('Color') || productJSON.options.includes('color') || productJSON.options.includes('COLOR')){
            const currentVariant = variant || window.globalVariables.product.currentVariant;
            const colorName = currentVariant.option1.toLowerCase();
            const colorMedia = [];
            mediaJSON.forEach(media => {
                let mediaAlt = media.alt;
                if(mediaAlt) mediaAlt = mediaAlt.toLowerCase();
                if(mediaAlt == colorName) colorMedia.push(media);
            });
            window.productMedia = colorMedia;

            if(window.globalVariables.templateSuffix == 'layout2'){
                const imagesParent = document.querySelector('[data-productImagesContainer]');
                if(!imagesParent || colorMedia.length <= 0) return;
                let slidesHTML = '';
                colorMedia.forEach(function(i,v){
                    let imageAlt = i.alt.toLowerCase();
                    if(imageAlt == colorName){
                        if(i.media_type == "external_video"){
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else if(i.media_type == "video"){
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else{
                            slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                            <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });
                imagesParent.innerHTML= slidesHTML;
            }else{
                const thumbParent = document.querySelector('[data-thumbSlider]');
                const sliderParent = document.querySelector('[data-main-slider]');
    
                if(!thumbParent || !sliderParent || colorMedia.length <= 0) return;
    
                let thumbnailsHTML = '';
                let slidesHTML = '';
                colorMedia.forEach(function(i,v){
                    let imageAlt = i.alt.toLowerCase();
                    if(imageAlt == colorName){
                        if(i.media_type == "external_video"){
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else if(i.media_type == "video"){
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        }else{
                            thumbnailsHTML+= `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                            slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });
    
                let navDirection = thumbParent.dataset.direction || 'horizontal';
                let finalnavHTML = `
                    <div class="swiper-slider product-thumbnails" role="tree" 
                            data-slider='{
                                "direction": "${navDirection}",
                                "loop": false,
                                "slidesPerView": "6",
                                "spaceBetween": 15,
                                "grabCursor": true,
                                "slideToClickedSlide": true
                            }' >
                        <div class="swiper-wrapper">${thumbnailsHTML}</div>
                    </div>`;
                thumbParent.innerHTML= finalnavHTML;
    
                let finalHTML = `<slider-element class="swiper-container carousel">
                                    <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails"
                                        data-slider='{
                                                "loop": false,
                                                "slidesPerView": "1",
                                                "spaceBetween": 15,
                                                "grabCursor": true,
                                                "navigation": {
                                                    "nextEl": ".swiper-button-next",
                                                    "prevEl": ".swiper-button-prev"
                                                },
                                                "pagination": {
                                                    "el": ".swiper-pagination"
                                                }
                                            }' role="tree">
                                        <div class="swiper-wrapper" >${slidesHTML}</div>
                                        <div class="swiper-pagination"></div>
                                    </div>
                                </slider-element>`;
                sliderParent.innerHTML= finalHTML;
            }
            
            selectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
            selectors.zoomBtns.forEach((btn)=>{
                btn.addEventListener('click', (event)=>{
                    let currentTarget = event.target;
                    this.manageZoom(currentTarget);
                })
            });
        }
    }

    manageZoom(currentTarget){
        let currentSlide = currentTarget.closest('.product--media');
        let currentSlideIndex = 0;
        if(currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);
        
        let zoomSlider = '';
        window.productMedia.forEach(i => {
            if(i.media_type == "external_video"){
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn" data-aos="hero">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            }else if(i.media_type == "video"){
                zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                    <div class="custom-video-container">
                        <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                            <div class="cta-btn">
                                <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                    <i class="icon-play text-body"></i>
                                </button>
                                <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                    <i class="icon-pause"></i>
                                </button>
                            </div>
                            <div class="content-section">
                                <div class="poster-image">
                                    <img class="img-fluid"
                                    src="${i.preview_image.src}"
                                    alt="${i.alt}"/>
                                </div>
                            </div>
                            <div class="video-section" tabindex="0"></div>
                        </custom-video>
                    </div>
                </div>`;
            }else if(i.media_type == "image"){
                zoomSlider+= `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                    <img class="img-fluid" style="height: 90vh;object-fit: contain;"
                    src="${i.preview_image.src}"
                    alt="${i.alt}"/>
                </div>`;
            }
        });
        let finalHTML = `<slider-element class="swiper-container carousel">
            <div class="swiper swiper-slider zoom--product-images"
                data-slider='{
                        "loop": false,
                        "observer": true,
                        "observeParents": true,
                        "slidesPerView": "1",
                        "spaceBetween": 15,
                        "grabCursor": true,
                        "navigation": {
                            "nextEl": ".swiper-button-next",
                            "prevEl": ".swiper-button-prev"
                        },
                        "pagination": {
                            "el": ".swiper-pagination"
                        }
                    }' role="tree">
                <div class="swiper-wrapper" >${zoomSlider}</div>
                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev icon-previous fa-solid fa-caret-left"></div>
                <div class="swiper-button-next icon-next fa-solid fa-caret-right"></div>

            </div>
        </slider-element>`;

        const zoomContainer = document.getElementById('PopupModal-zoom');
        if(zoomContainer){
            zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
            zoomContainer.show();
            if (currentSlideIndex != 0) {
                currentSlideIndex = currentSlideIndex -1;   
            } else {
                currentSlideIndex = Array.from(currentSlide.parentNode.children).length - 1;
            }
            if(productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        }
    }
}

function productTabs(evt){
    var i, tablinks;
    tablinks = document.getElementsByClassName("tablink");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" open", "");
    }
    evt.currentTarget.closest('.tablink').className += " open";
}

typeof templateProductJS !== 'undefined' && new templateProductJS();



// back to top button
document.addEventListener("scroll", () => {
    if(window.scrollY > 100){
      document.getElementById('scroll-top-btn').classList.add('show');
    }
    else if(window.scrollY < 100){
      document.getElementById('scroll-top-btn').classList.remove('show');
    }
});

// Stay PDP when vehicle is selected
let pdpEasySearchFindInterval = setInterval(() => {
    if (easysearch && easysearch != undefined && easysearch != null) {
        clearInterval(pdpEasySearchFindInterval);
        const easySearchSubmitButton = document.getElementById('easysearch-search');
        easySearchSubmitButton.removeAttribute("onclick");
        easySearchSubmitButton.removeAttribute("href");
        easySearchSubmitButton.removeAttribute("id");
        easySearchSubmitButton.onclick = function(e) {
            e.preventDefault();
            easysearch.saveSearchParams(e.target);
            location.reload();
        };

        for (const restButton of document.querySelectorAll("[data-clear-vehicle]")) {
            restButton.setAttribute('pdp', 'yes');
        }
    }
}, 1000)
